import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const getActiveCampaignLite = params =>
  axios.get('/lite/participations/active', { params });
